import React from "react";

const TestimonialItem = ({ img, name, comment, location }) => {
  return (
    <div className="pb-5 testimonial">
      <div className="card h-100">
        <img src={img} className="d-block" alt="..." />
        <div className="card-body text-center">
          <h5 className="card-title">
            <span className="review-blue">{name}</span>{" "}
            <span className="review-yellow">{location}</span>
          </h5>
          <p className="comment text-secondary">
            <i>"{comment.slice(0, 150)}"</i>
          </p>
          {/* display the ratting */}
          <div className="testimonial-icon">
            <div className="review">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialItem;
